import React from 'react';

export default function MakeACTAnswer(){
    return(
        <>
        </>
    );
}